import { useCallback } from 'react';
import { Typography, Grid, Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ButtonWithFontAwesome from '@monorepo/shared/src/components/common/Buttons/ButtonWithFontAwesome';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import Config from '@monorepo/shared/src/config';

const t = (key: string, options?) => translate('preferences', key, options);

const PreferencesClassesAndGroups = () => {
  const classes = useStyles();

  const goToPli = useCallback(() => {
    const { pliUrl } = Config;
    window.open(pliUrl as string, '_blank')?.focus();
  }, []);

  return (
    <Grid item xs={12}>
      <Paper>
        <Typography variant="h5" className={`${classes.gridItem} ${classes.title}`}>
          {t('classesAndGroups')}
        </Typography>
        <Typography variant="body1" className={`${classes.gridItem} ${classes.body}`}>
          {t('classesAndGroupsDescription')}
        </Typography>
        <div className={`${classes.gridItem} ${classes.buttonDiv}`}>
          <ButtonWithFontAwesome
            onClick={goToPli}
            text={t('classesAndGroupsBtnText')}
            aria-label={t('classesAndGroupsBtnText')}
            variant="outlined"
            color="primary"
            isInverted
          />
        </div>
      </Paper>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(4),
  },
  title: {
    fontSize: '28px',
    paddingTop: '20px',
  },
  body: {
    fontSize: '18px',
  },
  buttonDiv: {
    paddingBottom: 15,
    marginTop: 45,
  },
}));

export default PreferencesClassesAndGroups;
